<div class="row">
  <div class="col-10 offset-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
    <div class="login-wrap">
      <h2>Reload Required</h2>

      <p>You're viewing an old version of PatientGo. Please reload the page.</p>

      <p><strong>Current Version:</strong> {{ currentVersion}}, <strong>Latest Version:</strong> {{ latestVersion }}</p>

      <div class="flex justify-center">
        <app-button text="Reload" (clicked)="hardRefresh()"></app-button>
      </div>
    </div>
  </div>
</div>
